'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShouldFetchInitialVisitorThreads = undefined;

var _reselect = require('reselect');

var _getIsEmbeddedInProduct = require('../../widget-ui/operators/getIsEmbeddedInProduct');

var _getShouldFetchInitialVisitorThreads = require('../operators/getShouldFetchInitialVisitorThreads');

var _getWidgetUiState = require('../../selectors/getWidgetUiState');

var _getIsFirstVisitorSession = require('../../visitor-identity/selectors/getIsFirstVisitorSession');

var getShouldFetchInitialVisitorThreads = exports.getShouldFetchInitialVisitorThreads = (0, _reselect.createSelector)([_getIsFirstVisitorSession.getIsFirstVisitorSession, _getWidgetUiState.getWidgetUiState], function (isFirstVisitorSession, widgetUi) {
  var isEmbeddedInProduct = (0, _getIsEmbeddedInProduct.getIsEmbeddedInProduct)(widgetUi);
  return (0, _getShouldFetchInitialVisitorThreads.getShouldFetchInitialVisitorThreads)({
    isFirstVisitorSession: isFirstVisitorSession,
    isEmbeddedInProduct: isEmbeddedInProduct
  });
});